import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Log } from "app/core/logging/log";
import { StockModel, Type } from "app/models/stock-model";
import { AppService } from "app/services/app/app.service";
import { SharedModule } from "app/shared.module";
import { Subscription } from "rxjs";

export interface CategoryFlat {
  id: number;
  name: string;
  level: number;
  expandable: boolean;
}

@Component({
    selector: 'app-category-selector',
    templateUrl: './category-selector.component.html',
    styleUrls: ['./category-selector.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class CategorySelectorComponent implements OnInit, OnChanges {

    currentStock$: Subscription;
    flatCategories:CategoryFlat [];
    form: FormGroup;
    @Input() selectedValue: string = '';
    @Output() onChangeValue = new EventEmitter<CategoryFlat>();

    constructor(
        private fb: FormBuilder,
        private appService: AppService
      ) {}
      
    ngOnInit(): void {

        this.currentStock$ = this.appService.currentStock$.subscribe((stock:StockModel)=>{
            if (!stock?.items) {
              this.flatCategories = [];
              return;
            }
            Log.debug('surrent stock', {stock});
            let level:number = 0;
            this.flatCategories = this.flatten(stock.items, level);
        });

        this.form = this.fb.group({
              selectedCategoryItem: ['', []]
        });

        this.form.get('selectedCategoryItem').valueChanges.subscribe(newValue => {
          console.log('Cambio detectado:', newValue);
          this.onChangeValue.emit(newValue);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.form || !changes['selectedValue']) {
          return;
        }

        const nextValue = changes['selectedValue'].currentValue;

        if (nextValue == null || nextValue === '') {
          this.form.get('selectedCategoryItem')?.setValue('', { emitEvent: false });
          return;
        }

        const selectedCategory = this.flatCategories?.find(cat => String(cat.id) === String(nextValue));
        this.form.get('selectedCategoryItem')?.setValue(selectedCategory ?? '', { emitEvent: false });
    }

    ngOnDestroy() {
        this.currentStock$?.unsubscribe();
    }


    flatten(categories: Type[], level = 0): CategoryFlat[] {
        let result: CategoryFlat[] = [];
        for (const cat of categories) {
          result.push({
            id: cat.id,
            name: cat.literals[AppService.langSel.name].name,
            level,
            expandable: !!cat.items?.length
          });
    
          if (cat.items) {
            result = result.concat(this.flatten(cat.items, level + 1));
          }
        }
        return result;
    }

}
